import moment from 'moment';
import { useLocale } from '~/hooks';

const ShortDate = ({ value }) => {
  const locale = useLocale();
  const dateFormatter = new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'numeric',
  });

  const date = moment(value);

  return dateFormatter.format(date);
};

export default ShortDate;
